const zhLang = {
  header: {
    setting: '设置',
    fullScreen: '全屏',
    exitFullscreen: '退出全屏',
    userCenter: '个人中心',
    logout: '退出账号',
    langLabel: '语言',
    zhTip: '中文',
    enTip: '英语',
    jaTip: '日语',
    koTip: '韩语'
  },
  button: {
    searchText: '搜索'
  },
  home: {
    welcome: '欢迎使用比翼后台管理系统模板工程',
    versionDoc: '新版本文档说明'
  },
  placeholderText: '请输入文字...',
  placeholderDate: '选择日期',
  submitText: '提交',
  cancelText: '取消',
  resetText: '重置',
  enterText: '请输入',
  searchText: '查询',
  newText: '新建',
  exportExcel: '导出',
  editText: '编辑',
  detailText: '详情',
  deleteText: '删除',
  operateText: '操作',
  deletePopTip: '您确定要删除这条数据吗?',
  successText: '提交成功',
  errorText: '提交失败',
  holder: '请输入',
  required: '必填',
  drawer: {
    title: {
      add: '新建',
      detail: '详情',
      edit: '编辑'
    }
  },
  dictionary: {
    boolean: {
      yesOrNo: () => [{ value: true, label: '是', slot: 'open' }, { value: false, label: '否', slot: 'close' }]
    }
  }
}

export default zhLang
